<div class="container-fluid" style="background-color: #1d2229">
  <div class="row">
    <div class="col-sm-2">
      <div class="content">
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary first-button" (click)="changeDock(21)"
                [ngStyle]="{ color: statusDocks(21) }">
                Doca 1
              </button>
            </div>
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary" (click)="changeDock(22)"
                [ngStyle]="{ color: statusDocks(22) }">
                Doca 2
              </button>
            </div>
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary" (click)="changeDock(23)"
                [ngStyle]="{ color: statusDocks(23) }">
                Doca 3
              </button>
            </div>
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary" (click)="changeDock(24)"
                [ngStyle]="{ color: statusDocks(24) }">
                Doca 4
              </button>
            </div>
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary" (click)="changeDock(25)"
                [ngStyle]="{ color: statusDocks(25) }">
                Doca 5
              </button>
            </div>
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary" (click)="changeDock(26)"
                [ngStyle]="{ color: statusDocks(26) }">
                Doca 6
              </button>
            </div>
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary" (click)="changeDock(27)"
                [ngStyle]="{ color: statusDocks(27) }">
                Doca 7
              </button>
            </div>
            <div class="d-grid gap-2 col-sm-12 mx-auto">
              <button type="button" class="btn btn-outline-primary" (click)="changeDock(28)"
                [ngStyle]="{ color: statusDocks(28) }">
                Doca 8
              </button>
            </div>

            <span class="divider"></span>

            <section class="navigation-buttons">
              <div class="d-grid gap-2 col-sm-12 mx-auto">
                <button type="button" class="btn btn-outline-primary" (click)="navigate('filas')">
                  Filas
                </button>
              </div>
              <div class="d-grid gap-2 col-sm-12 mx-auto">
                <button type="button" class="btn btn-outline-primary" (click)="openTimeTable()">
                  Time Table
                </button>
              </div>
            </section>

      </div>
    </div>


    <div class="col-sm-10" [ngStyle]="{ 'background-color': bgColor, color: ftColor }"
      style="text-align: center; position: relative;display: flex; flex-direction: column;align-items: center; justify-content: space-between;">

      <!-- Nome da Doca -->
      <app-dock [dock]="dock" [ngStyle]="{'color' : activeTrip ? '#fff' : '#000'}"></app-dock>

      <!-- Exibe app-takt somente se houver viagem ativa -->
      <ng-container *ngIf="activeTrip; else proximaViagemTemplate">
        <app-takt [takt]="takt" [bgColor]="bgColor"></app-takt>
      </ng-container>

      <div class="general-container">
        <!-- Informações da viagem ativa -->
        <ng-container *ngIf="activeTrip">
          <div class="box-start">
            <div *ngIf="activeTrip.extra == null" class="box-start-card-top">
              <p class="box-title">Chegada Prevista:</p>
              <p class="box-data">{{ activeTrip.inicioLCB || 'N/A' }}</p>
            </div>
            <div class="box-start-card-bottom">
              <p class="box-title">Chegada Real:</p>
              <p class="box-data">{{ formatarNumero(selectedDock?.status?.getHours()) }}:{{
                formatarNumero(selectedDock?.status?.getMinutes()) }}</p>
            </div>
          </div>

          <div class="box-info" [ngClass]="{ 'centered-box-info': activeTrip?.extra != null }">
            <p *ngIf="activeTrip.extra == null" class="destino">Viagem {{ activeTrip?.viagem || '' }}
            <p class="destino">{{ activeTrip?.destino || '' }} {{ activeTrip?.tipo || '' }}</p>
          </div>

          <div class="box-finish" *ngIf="activeTrip.extra == null">
            <div class="box-finish-card-top">
              <p class="box-title">Saída Prevista:</p>
              <p class="box-data">{{ activeTrip?.saidaLCB || 'N/A' }}</p>
            </div>
            <div class="box-finish-card-bottom">
              <p class="box-title">Saída Real:</p>
              <p class="box-data">{{ saidaReal }}</p>
            </div>
          </div>
        </ng-container>


        <!-- Template para próxima viagem -->
        <ng-template #proximaViagemTemplate>
          <div class="rainbow">
            <p class="rainbow-gap" *ngIf="nextTrip; else noNextTrip">
              <span class="next-trip">Próxima viagem:</span>
              <strong class="divider"></strong>
              <span class="trip-description">
                <ng-container *ngIf="nextTrip?.extra == null; else tripType">
                  <strong class="trip-number"> {{ nextTrip?.viagem }}</strong>
                  <br> Chegada: {{ nextTrip?.inicioLCB }}
                </ng-container>
                <ng-template #tripType>
                  {{ nextTrip?.tipo }}
                </ng-template>
              </span>
            </p>
          </div>
        </ng-template>

        <!-- Template sem viagens -->
        <ng-template #noNextTrip>
          <p class="rainbow-gap">
            {{ dockId != 0 ? 'Não há viagens na fila' : 'Escolha uma doca' }}
          </p>
        </ng-template>

      </div>
    </div>
  </div>
</div>

<app-time-table [toggle]="toggle" (toggleChange)="onToggleChange($event)"></app-time-table>
